import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Layout from '../../components/layout/Layout';
import { ResetPassword } from '../../components/pages';
import { resetPassword } from '../../api/v1/put';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    password: '',
    confirmationPassword: '',
  });
  const [resetPasswordStatus, setResetPasswordStatus] = useState({
    isPasswordMatch: true,
    isSubmitting: false,
    isError: false,
    isSuccessModalShown: false,
  });
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResetPasswordStatus((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));
    setErrorMessage('');

    if (formData.password !== formData.confirmationPassword) {
      setResetPasswordStatus((prevState) => ({
        ...prevState,
        isSubmitting: false,
        isPasswordMatch: false,
      }));
    } else {
      try {
        const actionToken = searchParams.get('action_token');

        await resetPassword({
          action_token: actionToken,
          new_password: formData.password,
          retype_password: formData.confirmationPassword,
        });
        setResetPasswordStatus((prevState) => ({
          ...prevState,
          isPasswordMatch: true,
          isSubmitting: false,
          isError: false,
          isSuccessModalShown: true,
        }));
      } catch (error) {
        setErrorMessage(
          `Oops there is an error! Code: ${error.response.status}, Message: ${error.response.data.message}`,
        );
      } finally {
        setResetPasswordStatus((prevState) => ({
          ...prevState,
          isSubmitting: false,
          isPasswordMatch: true,
        }));
      }
    }
  };

  return (
    <Layout isHeaderShown={false} isPaddingActive={false}>
      <ResetPassword
        formData={formData}
        resetPasswordStatus={resetPasswordStatus}
        setResetPasswordStatus={setResetPasswordStatus}
        errorMessage={errorMessage}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </Layout>
  );
};

export default ResetPasswordPage;
